<div class="links">
  @if ((isAuthorized | async) && !(isAdmin| async)) {
    <div class="admin-link customer"
      >
      <span (click)="onAdminClick()">
        {{ "BUTTON.GOTO.ADMIN" | translate }}&nbsp;
        <i class="fal fa-cogs"
          aria-hidden="true">
        </i>
      </span>
    </div>
  }
  @if ((isAdmin | async)) {
    <div class="admin-link"
      >
      <span (click)="onCustomerClick()">
        {{ "BUTTON.GOTO.FRONT" | translate }}
      </span>
    </div>
  }
</div>
